import { render, staticRenderFns } from "./GalleryBaseForm.vue?vue&type=template&id=a03b08c4&scoped=true&"
import script from "./GalleryBaseForm.vue?vue&type=script&lang=js&"
export * from "./GalleryBaseForm.vue?vue&type=script&lang=js&"
import style0 from "./GalleryBaseForm.vue?vue&type=style&index=0&id=a03b08c4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a03b08c4",
  null
  
)

export default component.exports